// @generated by scripts/gen-modules.mjs
import { RouteObject, Navigate } from 'react-router-dom';
import { EssentialsRoutes } from './modules/essentials';
import { AdvancedRoutes } from './modules/advanced';
import { CpqRoutes } from './modules/cpq';
import { FieldRoutes } from './modules/field';
import { IntelligenceRoutes } from './modules/intelligence';
import { SequencesRoutes } from './modules/sequences';
import { ContractsRoutes } from './modules/contracts';

export const salesRoutes: RouteObject[] = [
  { path: '', element: <Navigate to="essentials/leads" replace /> },
  EssentialsRoutes,
  AdvancedRoutes,
  CpqRoutes,
  FieldRoutes,
  IntelligenceRoutes,
  SequencesRoutes,
  ContractsRoutes,
];

export default salesRoutes;
